<template>
	<div v-if="goodsShow">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<div v-if="type == 'design' && selectdItem.compontChildren[0].data.classfiy.length == 0"
			style="font-size: 16px;">请添加分类商品</div>
		<div v-if="selectdItem.compontChildren[0].data.classfiy.length > 0 && selectdItem.compontChildren[0].layoutConfig.type == 'tab'"
			style="width: 100%;">
			<div style="display: flex;align-items: center;justify-content:center;width: 100%;">
				<div style="margin: 5px;"
					v-for="(classfiyItem,classfiyIndex) in selectdItem.compontChildren[0].data.classfiy"
					:key="classfiyIndex">
					<div style="margin: auto;text-align: center;cursor: pointer;" @click="changeTab(classfiyItem)"
						:style="{
							fontSize:selectdItem.compontChildren[0].layoutConfig.titleSize + 'px',
						fontFamily:selectdItem.compontChildren[0].layoutConfig.titleFamily,
						color:classfiyItem.classfiyId == tab?selectdItem.compontChildren[0].layoutConfig.selectColor:selectdItem.compontChildren[0].layoutConfig.noSelectColor
					}">
						{{classfiyItem.classfiyLang?$t(`h.${classfiyItem.classfiyLang}`):classfiyItem.classfiyName}}
					</div>
				</div>
			</div>
			<div style="width: 100%;"
				v-for="(classfiyItem,classfiyIndex) in selectdItem.compontChildren[0].data.classfiy"
				:key="classfiyIndex">
				<div style="width: 100%;margin-top: 10px;"
					v-if="classfiyItem.classfiyId == tab && goodsObj[classfiyItem.classfiyId]">
					<div :style="getColumns()"
						style="width: 100%;display: grid;margin-top: 5px;justify-content: space-around;">
						<single-goods style="max-width: 100%;" v-for="(item,index) in goodsObj[classfiyItem.classfiyId]"
							:key="index" :goodsData="item" :equipment="equipment" :selectdItem="selectdItem"
							:systemConfig="systemConfig" :type="type"></single-goods>
					</div>
				</div>
			</div>
		</div>
		<div v-if="selectdItem.compontChildren[0].data.classfiy.length > 0 && selectdItem.compontChildren[0].layoutConfig.type == 'block'"
			style="width: 100%;">
			<div style="display: flex;align-items: center;justify-content:center;width: 100%;flex-direction: column;">
				<div style="margin: 10px;width: 100%;"
					v-for="(classfiyItem,classfiyIndex) in selectdItem.compontChildren[0].data.classfiy"
					:key="classfiyIndex">
					<div style="margin: auto;text-align: center;cursor: pointer;" @click="changeTab(classfiyItem)"
						:style="{
							fontSize:selectdItem.compontChildren[0].layoutConfig.titleSize + 'px',
							fontFamily:selectdItem.compontChildren[0].layoutConfig.titleFamily,
						color:selectdItem.compontChildren[0].layoutConfig.selectColor
					}">
						{{classfiyItem.classfiyName}}
					</div>
					<div style="width: 100%;margin-top: 16px;" v-show="goodsObj[classfiyItem.classfiyId]">
						<div :style="getColumns()"
							style="width: 100%;display: grid;margin-top: 5px;justify-content: space-around;">
							<single-goods style="max-width: 100%;"
								v-for="(item,index) in goodsObj[classfiyItem.classfiyId]" :key="index" :goodsData="item"
								:equipment="equipment" :selectdItem="selectdItem" :systemConfig="systemConfig"
								:type="type"></single-goods>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div style="width: 100%;height: 100%;"
			v-if="selectdItem.compontChildren[0].data.classfiy.length > 0 && selectdItem.compontChildren[0].layoutConfig.type == 'list'">
			<div style="display: flex;align-items: center;justify-content:center;width: 100%;">
				<div style="margin: 5px;"
					v-for="(classfiyItem,classfiyIndex) in selectdItem.compontChildren[0].data.classfiy"
					:key="classfiyIndex">
					<div style="margin: auto;text-align: center;cursor: pointer;" @click="changeTab(classfiyItem)"
						:style="{
							fontSize:selectdItem.compontChildren[0].layoutConfig.titleSize + 'px',
						fontFamily:selectdItem.compontChildren[0].layoutConfig.titleFamily,
						color:classfiyItem.classfiyId == tab?selectdItem.compontChildren[0].layoutConfig.selectColor:selectdItem.compontChildren[0].layoutConfig.noSelectColor
					}">
						{{classfiyItem.classfiyName}}
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 100%;margin-top: 10px;"
				v-for="(classfiyItem,classfiyIndex) in selectdItem.compontChildren[0].data.classfiy"
				:key="classfiyIndex">
				<PreciseDragScroll style="height: 100%;width: 100%;" :equipment="equipment"
					v-if="goodsObj[classfiyItem.classfiyId] && classfiyItem.classfiyId == tab">
					<single-goods :style="{
						width:getListWidth(),
						marginLeft:index != 0?equipment == 'pc'?(selectdItem.compontChildren[0].layoutConfig.goodsConfig.columnGap + 'px'):(selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneColumnGap + 'px'):'0px'
					}" v-for="(item,index) in goodsObj[classfiyItem.classfiyId]" :key="index" :goodsData="item" :equipment="equipment"
						:selectdItem="selectdItem" :systemConfig="systemConfig" :type="type"></single-goods>
				</PreciseDragScroll>
			</div>
		</div>
	</div>
</template>

<script>
	import PreciseDragScroll from './PreciseDragScroll.vue'
	import singleGoods from './singleGoods.vue'
	import {
		getDesignProducts,
		designGetCategoryProduct,
		getCategoryProduct
	} from '../../api/all.js'
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import lodash from 'lodash';
	export default {
		components: {
			singleGoods,
			PreciseDragScroll
		},
		props: {
			equipment: {
				type: String,
				default: "pc"
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
		},
		watch: {
			selectdItem: {
				immediate: true,
				deep: true,
				handler: async function(newVal, oldVal) {
					console.log('newValnewValnewVal1', newVal)
					let classfiy = newVal.compontChildren[0].data.classfiy
					if (this.type == 'design') {
						if (newVal.compontChildren[0].layoutConfig.type == 'tab') {
							if (this.firstLoad) {
								newVal.compontChildren[0].layoutConfig.reLoad = true
								this.tab = classfiy[0].classfiyId + ''
								await this.getData(classfiy[0].classfiyId, classfiy[0].num, classfiy[0])
								this.firstLoad = false
								return
							}
							if (classfiy.length > 0 && newVal.compontChildren[0].layoutConfig.reLoad) {
								
								for (let i = 0; i < classfiy.length; i++) {
									// this.tab = classfiy[i].classfiyId + ''
									await this.getData(classfiy[i].classfiyId, classfiy[i].num, classfiy[i])
								}
							}
							if(classfiy.length == 1){
								this.tab = classfiy[0].classfiyId + ''
							}
						}
						if (newVal.compontChildren[0].layoutConfig.type == 'block') {
							if (this.firstLoad) {
								newVal.compontChildren[0].layoutConfig.reLoad = true
								this.firstLoad = false
							}
							if (newVal.compontChildren[0].layoutConfig.reLoad) {
								for (let i = 0; i < classfiy.length; i++) {
									await this.getData(classfiy[i].classfiyId, classfiy[i].num, classfiy[i])
								}
								newVal.compontChildren[0].layoutConfig.reLoad = false
							}
						}
						
						if (newVal.compontChildren[0].layoutConfig.type == 'list') {
							if (this.firstLoad) {
								newVal.compontChildren[0].layoutConfig.reLoad = true
								this.tab = classfiy[0].classfiyId + ''
								await this.getData(classfiy[0].classfiyId, classfiy[0].num, classfiy[0])
								this.firstLoad = false
								return
							}
							if (classfiy.length > 0 && newVal.compontChildren[0].layoutConfig.reLoad) {
								for (let i = 0; i < classfiy.length; i++) {
									// this.tab = classfiy[i].classfiyId + ''
									await this.getData(classfiy[i].classfiyId, classfiy[i].num, classfiy[i])
								}
							}
						}
					} else {
						if (newVal.compontChildren[0].layoutConfig.type == 'tab') {
							// 默认第一个分类的数据已经加载
							if (classfiy.length > 0 && !this.goodsObj[classfiy[0].classfiyId]) {
								this.tab = classfiy[0].classfiyId + ''
								this.goodsObj[classfiy[0].classfiyId] = classfiy[0].data
							}
						} else {
							console.log('classfiy123456',classfiy)
							if (classfiy.length > 0) {
								classfiy.forEach(item => {
									console.log('classfiy123456item',item.data)
									this.tab = item.classfiyId + ''
									this.goodsObj[item.classfiyId] = item.data
								})
								console.log('this.goodsObj',this.goodsObj)
								this.goodsShow = false
								this.$nextTick(()=>{
									this.goodsShow = true
								})
							}
						}
					}
				}
			},
		},
		data() {
			return {
				goodsShow:true,
				tab: "",
				loading: false,
				goodsObj: {},
				firstLoad: true,
			}
		},
		computed: {
			...mapState("lowCodeStore", ['goodsConfig']),
		},
		mounted() {

			if (this.selectdItem.compontChildren[0].layoutConfig.followClassfiy) {
				if (this.goodsConfig.length > 0) {
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig = lodash.cloneDeep(this.goodsConfig[0])
					this.$forceUpdate()
				}
			}

			let classfiy = this.selectdItem.compontChildren[0].data.classfiy
			if (classfiy.length > 0) {
				this.tab = classfiy[0].classfiyId + ''
			}
		},
		methods: {
			getListWidth() {

				// layoutConfig
				// goodsConfig
				// width: 250,
				// height: 250,
				// phoneWidth: 250,
				// phoneHeight: 250,
				let goodsConfig = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig
				if (this.equipment == 'pc') {
					return (goodsConfig.width + goodsConfig.padding[1] + goodsConfig.padding[2]) + 'px'
				}
				if (this.equipment == 'phone') {
					return (goodsConfig.phoneWidth + goodsConfig.padding[1] + goodsConfig.padding[2]) + 'px'
				}
			},
			changeTab(classfiyItem) {
				this.goodsShow = false
				this.tab = classfiyItem.classfiyId
				if (!this.goodsObj[this.tab]) {
					this.getData(this.tab, classfiyItem.num, classfiyItem)
				}
				this.$nextTick(()=>{
					this.goodsShow = true
				})
			},
			
			
			getColumns() {
				let num = 1
				if (this.equipment == 'pc') {
					num = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.pcNum
				} else {
					num = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneNum
				}
				let gridRowGap;
				let gridColumnGap;
				if(this.equipment == 'pc'){
					gridRowGap = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.rowGap + 'px'
					gridColumnGap = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.columnGap + 'px'
				}else{
					gridRowGap = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneRowGap + 'px'
					gridColumnGap = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneColumnGap + 'px'
				}
				return {
					gridRowGap,
					gridColumnGap,
					gridTemplateColumns: `repeat(auto-fill, calc(${parseInt(100 / num)}% - ${this.equipment == 'pc'?this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.columnGap: this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneColumnGap}px))`
				}
			},
			async getData(id, num, classfiyItem) {
				try {
					this.loading = true
					console.log('selectdItemselectdItem22222', this.selectdItem)
					let wsid = this.$cookies.get("wsid")
					let data
					if (this.type == 'design') {
						data = await designGetCategoryProduct({
							wsid,
							id,
							num
						})
					} else {
						data = await getCategoryProduct({
							id,
							num
						})
					}

					this.goodsObj[id + ''] = data.data.data
					this.loading = false
					console.log('classfiyItemclassfiyItem', this.goodsObj)
					this.$forceUpdate()
				} catch (e) {
					console.log('ee', e)
					this.loading = false
				}
			},
		}
	}
</script>

<style>
</style>